
import { Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { BaseRoadmapItem } from '../data-model'

export default class CockroachSVG extends Vue {
    @Prop({ required: true }) mdata!: BaseRoadmapItem
}
